import React, { useState } from 'react';

const IconButtonCont = ({ data,setVisibleMessage,setVisibleFile,visibleMessage,visibleFile }) => {
    return (
        <div className="icon-button-cont">
            <div className="tool-tip-cont">
                <div className="tool-tip">Հաղորդագրություններ</div>
                <div className="icon-button"
                     onClick={() => setVisibleMessage(!visibleMessage)}>
                    <div className="add-file">
                        <i className="fas fa-envelope" />
                        {!visibleMessage && data?.messages?.length !== 0 ? (
                            <div className="tasks-around">{data?.messages?.length}</div>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="tool-tip-cont">
                <div className="icon-button"
                     onClick={() => setVisibleFile(!visibleFile)}>
                    <div className="tool-tip">Ֆայլերի ցանկ</div>
                    <div className="add-file">
                        <i className="fas fa-file" />
                        {data?.attachments?.length !== 0 ? (
                            <div className="tasks-around">{data?.attachments?.length}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IconButtonCont;
